import { Helmet } from "react-helmet-async";
import { useSite } from "../../context/SiteContext";

const clean = (v) => (v || "").trim().replace(/[^A-Za-z0-9_-]/g, "");

export const Tracking = () => {
  const { settings } = useSite();
  const ga = clean(settings.ga4_id);
  const gtm = clean(settings.gtm_id);
  const px = clean(settings.meta_pixel_id);
  const gsc = (settings.gsc_verification || "").trim();
  return (
    <Helmet>
      {gsc && <meta name="google-site-verification" content={gsc} />}
      {ga && <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga}`} />}
      {ga && (
        <script>{`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${ga}');`}</script>
      )}
      {gtm && (
        <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtm}');`}</script>
      )}
      {px && (
        <script>{`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${px}');fbq('track','PageView');`}</script>
      )}
    </Helmet>
  );
};
